import { InjectionToken } from '@angular/core';

export interface Environment {
  production: boolean;
  apiUrl: string;
  serverUrl: string;
  webSocketPath: string;
  webSocketPort: number;
  customization: any;
}

export const ENV = new InjectionToken<Environment>('Environment');
export const API_URL = new InjectionToken<string>('ApiUrl');
export const SERVER_URL = new InjectionToken<string>('ServerUrl');
export const WEB_SOCKET_URL = new InjectionToken<string>('WebSocketUrl');
export const DIALOG_WIDTH_XL = new InjectionToken<string>('DialogWidthXl');
export const DIALOG_WIDTH_M = new InjectionToken<string>('DialogWidthM');
